import { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ROUTES from '../../routes';
import api from '../../config/axiosInstance';

import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';

const AddSpaceCard = () => {
    const formRef = useRef(null);
    const navigate = useNavigate();

    const [form, setForm] = useState({ 
        title: '', 
        description: ''
    });

    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const [submitting, setSubmitting] = useState(false);

    const handleFormSubmit = async () => {
        setImage(null);
        setImagePreview(null);
        
        if (!$(formRef.current).valid()) return;

        const formData = new FormData();
        Object.entries(form).forEach(([k, v]) => formData.append(k, v));
        
        formData.append("image", image);

        try {
            setSubmitting(true);
            const res = await api.post(
                '/space-cards/create',
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            showToast('success', res.data.message, 'Success');
            navigate(ROUTES.SPACECARDS);
        } catch (err) {
            handleErrors(err);
        }
        finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        const $ = window.jQuery;

        $.validator.addMethod('extension', function (value, element, allowedExtensions) {
            var fileName = value;
            var extension = fileName.split('.').pop().toLowerCase();
            return $.inArray(extension, allowedExtensions) !== -1;
        }, 'Invalid file type');

        $.validator.addMethod("ckeditorRequired", function (value, element) {
            const textOnly = value.replace(/<[^>]*>/g, '').trim();
            return textOnly.length > 0;
        }, "This field is required");

        if (formRef.current && window.$.fn.validate) {
            window.$(formRef.current).validate({
                ignore: ".ck-editor *",
                rules: {
                    title: {
                        required: true,
                        minlength: 3
                    },
                    description: {
                        required: true,
                        minlength: 3,
                        ckeditorRequired: true
                    },
                    image: {
                        required: true,
                        extension: ['jpg', 'jpeg', 'png', 'svg', 'webp']
                    }
                },
                messages: {
                    title: {
                        required: "Please enter a title",
                        minlength: "Title must be at least 3 characters"
                    },
                    description: {
                        required: "Please enter description",
                        minlength: "Description must be at least 3 characters"
                    },
                    image: {
                        required: "Please upload a image",
                        extension: "Only jpg, jpeg, png allowed"
                    }
                },
                errorElement: "label",
                validClass: "is-valid",
                errorClass: "is-invalid text-danger",
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(errorClass).addClass(validClass);
                }
            });
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.SPACECARDS}>Space Cards</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={ROUTES.ADD_SPACECARD}>Add Space Card</Link>
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Add Space Card</h4>
                        </div>
                        <div className="card-body">
                            <form ref={formRef} noValidate>
                                <div className="row">
                                    
                                    {[
                                        { label: "Title", name: "title" }
                                    ].map(({ label, name }) => (
                                        <div key={name} className="mb-3 col-lg-6 col-md-6 col-sm-6">
                                            <label htmlFor={name}>{label}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name={name}
                                                id={name}
                                                value={form[name]}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    ))}

                                    {[
                                        { name: 'description', label: 'Description' }
                                    ].map(({ name, label }) => (
                                        <div key={name} className="mb-3 col-lg-6 col-md-6 col-sm-6">
                                            <div className="mb-3 col-lg-12">
                                                <label className="form-label">{label}</label>
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    config={{
                                                        toolbar: [
                                                            'heading', '|',
                                                            'bold', 'italic', 'link', 'code', 'codeBlock', 
                                                            '|', 'bulletedList', 'numberedList'
                                                        ]
                                                    }}
                                                    data={form[name]}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        setForm(prev => ({ ...prev, [name]: data }));
                                                        document.querySelector(`input[name="${name}"]`).value = data;
                                                    }}
                                                />
                                                <input
                                                    type="hidden"
                                                    name={name}
                                                    value={form[name]}
                                                />
                                            </div>
                                        </div>
                                    ))}


                                    <div className="mb-3 col-lg-6 col-md-6 col-sm-6">
                                        <label htmlFor="logo" className="form-label">Image</label>
                                        <div className="input-group custom_file_input">
                                            <div className="form-file">
                                                <input
                                                    name="image"
                                                    type="file"
                                                    className="form-file-input form-control"
                                                    onChange={handleImageChange}
                                                />
                                            </div>
                                            <span className="input-group-text">Upload</span>
                                        </div>
                                        {imagePreview && (
                                            <div className="mt-2">
                                                <img
                                                    src={imagePreview}
                                                    alt="Preview"
                                                    style={{ width: 100, height: 100, objectFit: 'cover' }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                </div>

                                <div className="pt-3">
                                    <button
                                        type="button"
                                        onClick={handleFormSubmit}
                                        className="btn btn-sm btn-primary me-2"
                                        disabled={submitting}
                                    >
                                        {submitting ? (
                                            <>
                                                <i className="spinner-border spinner-border-sm me-1"></i>
                                                Submit
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-floppy-disk me-1"></i>
                                                Submit
                                            </>
                                        )}
                                    </button>
                                    <Link to={ROUTES.DEVELOPERS} className="btn btn-sm btn-danger light">
                                        <i className="fas fa-times-circle"></i>&nbsp;
                                        Cancel
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddSpaceCard
